import { useState } from 'react';
import useGetNotifications from '../notifications/dashboardNotifications/useGetNotifications';
import useGetActiveJobApplications from '../jobs/useGetActiveJobApplications';
import useGetPendingApplications from '../jobs/useGetPendingJobApplications';
import useGetTotalApplicationsCount from '../jobs/useGetTotalApplicationsCount';
import { useAppSelector } from '../../../redux/store';

const useMiniLoad = () => {
  const { authData } = useAppSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  const { getNotifications } = useGetNotifications();
  const { getTotalApplicationsCount } = useGetTotalApplicationsCount();
  const { getActiveJobApplications } = useGetActiveJobApplications();
  const { getPendingApplications } = useGetPendingApplications();

  const getMiniLoadData = () => {
    setLoading(true);

    if (authData?.id) {
      Promise.all([
        getNotifications(),
        getTotalApplicationsCount(),
        getActiveJobApplications(),
        getPendingApplications(),
      ])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  return { getMiniLoadData, loading };
};

export default useMiniLoad;
